<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Edit Guidance</h4>
        </md-card-header>

        <form @submit.prevent="update">
          <md-card-content>
            <div class="text-right">
              <md-button @click="goBack" class="md-primary md-dense">
                Back to List
              </md-button>
            </div>
            <select-input-horizontal
                v-model="guidance.port.id"
                :options="available_departments_dropdown"
                placeholder="Select Port"
                label="Port"
                name="name"
                track-by="id"
                main-class="md-layout"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.port_id"
            ></select-input-horizontal>

            <select-input-horizontal
                v-model="guidance.vendor"
                :options="vendors"
                placeholder="Select Vendor"
                label="Vendor"
                name="name"
                track-by="id"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.vendor_id"
            ></select-input-horizontal>
            <select-input-horizontal
                v-model="guidance.guidance_type"
                :options="types"
                placeholder="Select Guidance Type"
                label="Guidance Type"
                name="name"
                track-by="name"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.guidance_type"
            ></select-input-horizontal>
            <select-input-horizontal
                v-if="guidance.guidance_type==='Per Work Done'"
                v-model="guidance.pay_code"
                :options="codes"
                placeholder="Select Charging Unit"
                label="Charging Unit"
                name="name"
                track-by="id"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.pay_code"
            ></select-input-horizontal>
            <select-input-horizontal
                v-model="guidance.guidance_category_id"
                :options="available_guidance_categories_dropdown"
                placeholder="Select Guidance Category"
                label="Guidance Category"
                name="name"
                track-by="id"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.guidance_category_id"
            ></select-input-horizontal>
            <select-input-horizontal
                v-model="guidance.duration"
                :options="durations"
                placeholder="Select Duration"
                label="Duration"
                name="name"
                track-by="name"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.duration"
            ></select-input-horizontal>
            <div v-if="guidance.duration">
              <div v-if="!isMonthDuration">
                <div class="md-layout" v-if="guidance.duration !== 'Month'">
                  <label class="md-layout-item md-size-25 md-form-label">
                    Start Date
                  </label>
                  <div class="md-layout-item">
                    <md-datepicker
                        v-model="guidance.start_date"
                        md-immediately
                        :md-model-type="String"
                        :md-disabled-dates="disabledStartDates"
                        :class="{ 'md-invalid': !!apiValidationErrors.start_date }"
                    >
                      <label>Select date ...</label>
                      <validation-error :errors="apiValidationErrors.start_date"/>
                    </md-datepicker>
                  </div>
                </div>

                <div class="md-layout" v-if="!isDayDuration">
                  <label class="md-layout-item md-size-25 md-form-label">
                    End Date
                  </label>
                  <div class="md-layout-item">
                    <md-datepicker
                        v-model="guidance.end_date"
                        :md-model-type="String"

                        :md-disabled-dates="setEndDateDisable"
                        :class="{ 'md-invalid': !!apiValidationErrors.end_date }"
                    >
                      <label>Select date ...</label>
                      <validation-error :errors="apiValidationErrors.end_date"/>
                    </md-datepicker>
                  </div>
                </div>
              </div>
              <div v-else>
                <select-input-horizontal
                    v-model="selected_month"
                    :options="months"
                    placeholder="Select Guidance Type"
                    label="Guidance Month"
                    name="name"
                    track-by="id"
                    main-class="md-layout"
                    label-class="md-layout-item md-size-25 md-form-label"
                    :error="apiValidationErrors.start_date"
                    @select="monthDates"
                ></select-input-horizontal>

              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">
                Name
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="guidance.name"/>
                  <validation-error :errors="apiValidationErrors.name"/>
                </md-field>
              </div>
            </div>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button type="submit" class="md-success">Update Guidance</md-button>
          </md-card-actions>
        </form>
      </md-card>
    </div>
  </div>
</template>

<script>
import {ValidationError} from '@/components';
import formMixin from '@/mixins/form-mixin';
import SelectInputHorizontal from '@/components/Inputs/SelectInputHorizontal';

export default {
  name: 'EditGuidance',

  components: {
    ValidationError,
    SelectInputHorizontal
  },

  mixins: [formMixin],

  data() {
    return {
      guidance: {
        type: 'guidances',
        id: null,
        name: null,
        vendor_id: null,
        port_id: null,
        guidance_category_id: null,
        guidance_type: null,
        duration: null,
        start_date: null,
        end_date: null,
        pay_code: null,
        guidance_number: null,

        department: {
          id: null,
          type: 'departments',
          name: null
        },
        vendor: {
          id: null,
          type: 'vendors',
          name: null
        },
        port: {
          id: null,
          type: 'ports',
          name: null
        },

        relationshipNames: ['department', 'vendor', 'port']
      },

      vendors: [],
      available_departments: [],
      available_departments_dropdown: [],
      available_guidance_categories: [],
      available_guidance_categories_dropdown: [],

      selected_month: null,
      selectedPort: {},

      months: [
        {id: 1, name: 'January'},
        {id: 2, name: 'February'},
        {id: 3, name: 'March'},
        {id: 4, name: 'April'},
        {id: 5, name: 'May'},
        {id: 6, name: 'June'},
        {id: 7, name: 'July'},
        {id: 8, name: 'August'},
        {id: 9, name: 'September'},
        {id: 10, name: 'October'},
        {id: 11, name: 'November'},
        {id: 12, name: 'December'}
      ],

      durations: [
        {id: 'Day', name: 'Day'},
        {id: 'Week', name: 'Week'},
        {id: 'Month', name: 'Month'},
        {id: 'Custom', name: 'Custom'}
      ],

      types: [
        {
          id: 'Per Man Hour',
          name: 'Per Man Hour'
        },
        {
          id: 'Per Work Done',
          name: 'Per Work Done'
        }
      ],
      codes: [
        { id: 'PT', 'name': 'Per Tonnage (PT)' },
        { id: 'PU', 'name': 'Per Unit (PU)' },
        { id: 'TU', 'name': 'Per TEUs (TU)' }
      ],
    };
  },

  async created() {
    await Promise.all([
      this.getDepartments(),
      this.getDepartmentDropDowns(),
      this.getGuidanceCategories(),
      this.getGuidanceCategoryDropDowns()
    ]);

    await this.get();
  },

  computed: {
    disabledStartDates() {
      return date => false;
    },

    setEndDateDisable() {
      return date => {
        if (!this.guidance.start_date) {
          return false;
        }

        return new Date(date) <
            new Date(this.guidance.start_date);
      };
    },

    isMonthDuration() {
      return (
          this.guidance.duration &&
          this.guidance.duration.id === 'Month'
      );
    },

    isDayDuration() {
      return (
          this.guidance.duration &&
          this.guidance.duration.id === 'Day'
      );
    }
  },
  watch: {
    async 'guidance.port.id'(portId) {

      console.log('PORT ID CHANGED', portId);

      if (!portId) {
        this.vendors = [];
        this.guidance.vendor = null;
        return;
      }

      const selectedPort =
          this.available_departments_dropdown.find(
              p => String(p.id) === String(portId)
          );

      console.log('SELECTED PORT', selectedPort);

      this.selectedPort = selectedPort;

      await this.fetchVendors();
    }
  },

  methods: {
    async get() {
      try {
        console.log(this.guidance);
        await this.$store.dispatch(
            'guidances/view',
            {
              id: this.$route.params.id,
              include:
                  'department,vendor,port,guidanceCategory'
            }
        );

        const guidance =
            this.$store.getters[
                'guidances/guidance'
                ];

        this.guidance = {
          ...this.guidance,
          ...guidance
        };

        if (guidance.vendor) {
          console.log(guidance);
          console.log("DDDDDD");
          this.guidance.vendor_id = guidance.vendor.id;
          this.guidance.vendor = guidance.vendor;
        }

        if (guidance.port) {
          this.guidance.port_id = guidance.port.id;
        }

        if (guidance.guidanceCategory) {
          this.guidance.guidance_category_id =
              guidance.guidanceCategory.id;
        }

      } catch (e) {

        await this.$store.dispatch(
            'alerts/error',
            'Failed to load guidance.'
        );
      }
    },

    async update() {
      try {

        const payload = {
          ...this.guidance,
          id: this.$route.params.id
        };

        // payload.vendor_id=this.guidance.vendor
        payload.vendor_id = this.guidance.vendor
            ? (typeof this.guidance.vendor === 'object'
                ? this.guidance.vendor.id
                : this.guidance.vendor)
            : null;
        // Vendor
        if (payload.vendor && payload.vendor.id) {
          payload.vendor = {
            id: payload.vendor.id,
            type: 'vendors'
          };
        }

        // Port
        payload.port_id = this.guidance.port.id
        if (payload.port && payload.port.id) {
          payload.port = {
            id: payload.port.id,
            type: 'ports'
          };
        }

        // Guidance Category
        if (
            payload.guidanceCategory &&
            !payload.guidanceCategory.id
        ) {
          delete payload.guidanceCategory;
        }

        if (
            payload.relationships &&
            payload.relationships.guidanceCategory &&
            !payload.relationships.guidanceCategory.data &&
            !payload.relationships.guidanceCategory.data.id
        ) {
          delete payload.relationships.guidanceCategory;
        }


        await this.$store.dispatch(
            'guidances/update',
            payload
        );

        await this.$store.dispatch(
            'alerts/success',
            'Guidance updated successfully.'
        );

        this.goBack();

      } catch (e) {

        this.notifyException(e);
        this.notifyError('Oops, something went wrong!');

        this.setApiValidation(
            e.response.data.errors
        );
      }
    },

    async fetchVendors() {

      console.log('selectedPort', this.selectedPort);

      let params = {
        filter: {
          station: this.selectedPort ? this.selectedPort.station_id : ''
        }
      };

      console.log('params', params);

      await this.$store.dispatch('vendors/list', params);

      console.log(
          'vendors dropdown',
          this.$store.getters['vendors/dropdown']
      );

      this.vendors =
          this.$store.getters['vendors/dropdown'];
    },

    async getDepartments() {
      await this.$store.dispatch(
          'departments/list'
      );

      this.available_departments =
          this.$store.getters[
              'departments/dropdown'
              ];
    },

    async getGuidanceCategories() {
      await this.$store.dispatch(
          'guidanceCategories/list'
      );

      this.available_guidance_categories =
          this.$store.getters[
              'guidanceCategories/dropdown'
              ];
    },

    async getDepartmentDropDowns() {

      let params = {
        filter: {
          station: ''
        }
      };

      if (
          this.user_department &&
          this.user_department.station
      ) {
        params.filter.station =
            this.user_department.station.id;
      }

      await this.$store.dispatch(
          'ports/list',
          params
      );

      this.available_departments_dropdown =
          this.$store.getters[
              'ports/dropdown'
              ];
    },

    async getGuidanceCategoryDropDowns() {

      await this.$store.dispatch(
          'guidanceCategories/list'
      );

      this.available_guidance_categories_dropdown =
          this.$store.getters[
              'guidanceCategories/dropdown'
              ];
    },

    monthDates(month) {

      if (!month) {
        return;
      }

      const year =
          new Date().getFullYear();

      const startDate =
          new Date(
              year,
              month.id - 1,
              1
          );

      const endDate =
          new Date(
              year,
              month.id,
              0
          );

      this.guidance.start_date =
          startDate
              .toISOString()
              .split('T')[0];

      this.guidance.end_date =
          endDate
              .toISOString()
              .split('T')[0];
    },

    goBack() {
      this.$router.push({
        name: 'Guidances List'
      });
    }
  }
};
</script>
